/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Admin } from '../../../../utils/api';
import {
  Radio,
  Label,
  Modal,
  Loader,
  LargeButton,
  PowerDropdown,
  PowerDropdownCards,
} from '../../../../components';
import { ARMcontext, useViewport } from '../../../../utils/context/context';
import { CardModal } from '../cardModal/cardModal';
import { defaultNumberPlayers } from './constants';
import {
  Taxes,
  SponsorshipSection,
  InputWrapper,
  LabelDropdown,
  LabelAddCard,
  ContainerWrapper,
  SectionLeft,
  SectionRight,
  FormControl,
  FormBlock,
  ChoosePaymentRadios,
  ButtonWrapper,
  TotalSection,
  TotalSectionLabel,
  TotalSectionValue,
  MonthlyBox,
  MonthlyBoxText,
  MonthlyBoxValue,
  AvailableBox,
  AvailableBoxTop,
  AvailableBoxBottom,
  AvailableBoxTitle,
  AvailableBoxValue,
  ModalPayment,
  ContentModalPayment,
  TitleModalPayment,
  TextModalPayment,
  ModalPaymentButton,
} from './styles';
import { RadiosContainerColumn } from '../../styles';
import numberColumnFormatter from '../../../../utils/hooks/number-column-formatter';

const DEFAULT_TITLE_MODAL_PAYMENT = "Processing...";

export default () => {
  const { HandleToastMessage } = useContext(ARMcontext);
  const [sponsorPrices, useSponsorPrices] = useState<object | any>({});
  const [userCards, useUserCards] = useState<Array<any>>([]);
  const [addCardModal, useCardModal] = useState(false);
  const [cardsLoading, useCardsLoading] = useState(true);
  const [defaultCard, useDefaultCard] = useState<any>({});
  const [loadingPayment, setLoadingPayment] = useState<boolean>(false);
  const [titleModalPayment, setTitleModalPayment] = useState<string>(DEFAULT_TITLE_MODAL_PAYMENT);
  const [responsePayment, setResponseModalPayment] = useState<Object>({ message: '', status: '' });
  const [numberPlayers, useNumberPlayers] = useState<any>(defaultNumberPlayers[0]);
  const [sponsorshipsAvailable, setSponsorshipsAvailable] = useState<any>();

  const { width } = useViewport();
  const breakpointWidth = 720;

  const ADMIN = new Admin();

  useEffect(() => {
    GetSponsorPrices();
    FetchMembershipAvailable();
    FetchPaymentMethods();
  }, []);

  async function FetchPaymentMethods() {
    useCardsLoading(true);
    const response: any = await ADMIN.GetPaymentMethods();
    if (response.status) {
      useUserCards([...response.data]);
      const userDefaultCard = response.data.filter(card => card.default);
      useDefaultCard(userDefaultCard[0]);
      useCardsLoading(false);
    } else {
      useCardsLoading(false);
    }
  }

  async function GetSponsorPrices() {
    const SponsorPrices = await ADMIN.GetSponsorshipsLevels('yearly');
    if (SponsorPrices.status && !SponsorPrices?.data?.statusCode) {
      let sponsors = {}
      SponsorPrices.data.data.map(elem => sponsors[Object.keys(elem)[0]] = Object.values(elem)[0])
      useSponsorPrices(sponsors);
    } else {
      HandleToastMessage(SponsorPrices?.data?.message || 'Server error', true, 2000, 'error');
    }
  }


  async function FetchMembershipAvailable(): Promise<void> {
    const resMemberShip = await ADMIN.GetSponsorshipAvailable();
    setSponsorshipsAvailable(resMemberShip.data.data);
  }

  function usemodal(val) {
    useCardModal(val);
  }
  function handleClickOutside(e) {
    if (e.target.id === 'modal') {
      usemodal(false);
    }
  }
  async function ChangeDefaultCard(e: any) {
    //change default card
    const updateCard = await ADMIN.EditCard({ id: e.id, default: true });
    if (updateCard.status) {
      FetchPaymentMethods();
    }
  }

  function ChangeNumberPlayers(selectedOption: any) {
    useNumberPlayers(selectedOption);
  }

  function HandlePayYearly() {
    setLoadingPayment(true);
    let order = {
      paymentMethod: "stripe",
      stripeData: {
        paymentMethodId: defaultCard.id
      },
      membershipBlockData: {
        numberOfPlayers: numberPlayers.value,
        duration: 12,
        durationUnit: 'month'
      }
    }
    ADMIN.BuyMembership(order).then(data => {
      if (data.success) {
        setTitleModalPayment('Successful');
        setResponseModalPayment({ message: 'Your payment has been approved', status: 'success' });
        setTimeout(async () => {
          await FetchMembershipAvailable();
        }, 1000)
      } else {
        setTitleModalPayment('Unsuccessful');
        setResponseModalPayment({ message: data['message'], status: 'error' });
      }
    });
  }

  const CreditCardMethod = () => {
    return (<>
      {addCardModal && (
        <div onClick={handleClickOutside}>
          <CardModal handleModalFunction={usemodal} refreshCards={FetchPaymentMethods} />
        </div>
      )}
      {cardsLoading ? (
        <Loader height="90px" />
      ) : userCards.length > 0 ? (
        <InputWrapper>
          <LabelDropdown>CREDIT CARD</LabelDropdown>
          <LabelAddCard onClick={() => useCardModal(true)}>ADD NEW CREDIT CARD</LabelAddCard>
          <PowerDropdownCards
            mHeigth={'200px'}
            dataArray={userCards}
            primaryTitle={`************${defaultCard?.last4 ? defaultCard?.last4 : userCards[0].last4}`}
            onClick={ChangeDefaultCard}
            firstActve={true}
            mPadding="2px 0 2px 10px"
          />
        </InputWrapper>
      ) : (
        <LargeButton
          callback={() => useCardModal(true)}
          title="ADD A CREDIT CARD"
          lColor="#006BE1"
          rColor="rgba(0,122,255,1)"
          icon="plus"
          fullWidth={true}
          xMargin={'25px auto 10px 0px'}
          responsive="0px"
          fSize={"13px"}
        />
      )}
    </>)
  }

  const SponsorshipPrices = () => {
    return (<MonthlyBox>
      <MonthlyBoxText>Premium <br /> Yearly <br /> sponsorships</MonthlyBoxText>
      <MonthlyBoxValue>
        <sup>$</sup>
        <span>{sponsorPrices?.yearly}</span>
      </MonthlyBoxValue>
    </MonthlyBox>)
  }


  const PayNow = () => {
    return (<React.Fragment>
      <ButtonWrapper data-cy="button-pay-now">
        <LargeButton
          title={'Pay Now'}
          lColor="var(--SecondaryBlue);"
          rColor="var(--PrimaryBlue);"
          lMargin='0 10px'
          callback={HandlePayYearly}
          fullWidth={true}
          responsive="0px"
          simpleButton={true}
          bradius={"8px"}
          fSize={"16px"}
          disabled={userCards.length === 0 ? true : false}
        />
      </ButtonWrapper>
    </React.Fragment>
    )
  }

  const AvailableSponsorships = ({ count, bottomText }: { count: number, bottomText: string }) => {
    return (<AvailableBox membershipCount={count}>
      <AvailableBoxTop>
        <>
          <AvailableBoxValue membershipCount={count}>{count}</AvailableBoxValue>
          <AvailableBoxTitle>
            Premium Yearly <br /> sponsorships
          </AvailableBoxTitle>
        </>
      </AvailableBoxTop>
      <AvailableBoxBottom membershipCount={count}>{bottomText}</AvailableBoxBottom>
    </AvailableBox>)
  }

  const PurchasePlayers = ({
    changeMethod,
    dataArray,
    title,
  }) => {
    return (<FormBlock>
      <FormControl>
        <Label text="PLAYERS" fontWeight="600" fontSize="12px" color={'#3E464E'} />
        <InputWrapper>
          <PowerDropdown
            mHeigth="200px"
            onClick={changeMethod}
            search={false}
            dataArray={dataArray}
            primaryTitle={title}
            mPadding="4px 0 4px 10px"
            theme="gray"
            mWidth="100%"
          />
        </InputWrapper>
      </FormControl>
    </FormBlock>
    )
  }

  const PurchaseBill = () => {
    return (<React.Fragment>
      <FormBlock>
        <FormControl>
          <Label text="TAX(0%)" fontWeight="600" fontSize="15px" color={'#3E464E'} />
          <Taxes>$ 0.00 US</Taxes>
        </FormControl>
        <TotalSection>
          <TotalSectionLabel>Total</TotalSectionLabel>
          <TotalSectionValue>${numberPlayers.value && numberColumnFormatter(numberPlayers.value * sponsorPrices?.yearly, { digits: 2 })} US</TotalSectionValue>
        </TotalSection>
      </FormBlock>
    </React.Fragment>)
  }

  return (
    <SponsorshipSection>
      {loadingPayment && (
        <Modal minWidth='378px' padding="20px" margin="28vh auto 200px auto">
          <ModalPayment>
            <TitleModalPayment errorPayment={responsePayment['status']}>{titleModalPayment}</TitleModalPayment>
            {responsePayment['message'] !== '' && (<TextModalPayment>{responsePayment['message']}</TextModalPayment>)}
            {responsePayment['status'] === '' ? (
              <ContentModalPayment>
                <Loader height="40px" />
              </ContentModalPayment>
            ) : (
              <ModalPaymentButton>
                <LargeButton
                  lMargin="0"
                  title={'Ok'}
                  rColor="#ffffff"
                  lColor="#ffffff"
                  fColor="#5D6C76"
                  bColor="#F0F0F0"
                  xMargin="0 10px 0 0"
                  callback={() => {
                    setTitleModalPayment(DEFAULT_TITLE_MODAL_PAYMENT)
                    setResponseModalPayment({ message: '', status: '' })
                    setLoadingPayment(false)
                  }}
                />
              </ModalPaymentButton>
            )}
          </ModalPayment>
        </Modal>
      )}
      <>
        {width <= breakpointWidth ? (
          <ContainerWrapper>
            <AvailableSponsorships count={sponsorshipsAvailable?.types?.yearlyPrepay} bottomText={"Yearly Memberships Available"} />
            <SponsorshipPrices />
            <FormControl>
              <Label text="Payment method" fontWeight="600" fontSize="15px" color={'#3E464E'} />
              <RadiosContainerColumn>
                <Radio title={`Credit Card`} name="paymentOption" id="creditCard" checked={true} dynamicActive={true} size={'14px'} fontWeight={500} />
              </RadiosContainerColumn>
            </FormControl>
            <PurchasePlayers changeMethod={ChangeNumberPlayers} dataArray={defaultNumberPlayers} title={numberPlayers.name} />
            <CreditCardMethod />
            <PurchaseBill />
            <PayNow />
          </ContainerWrapper>
        ) : (
          <ContainerWrapper>
            <SectionLeft>
              <SponsorshipPrices />
              <FormControl>
                <Label text="Payment method" fontWeight="600" fontSize="15px" color={'#3E464E'} />
                <ChoosePaymentRadios>
                  <RadiosContainerColumn>
                    <Radio title={`Credit Card`} name="paymentOption" id="creditCard" checked={true} dynamicActive={true} size={'14px'} fontWeight={500} />
                  </RadiosContainerColumn>
                </ChoosePaymentRadios>
              </FormControl>
              <CreditCardMethod />
              <PayNow />
            </SectionLeft>
            <SectionRight>
              <AvailableSponsorships count={sponsorshipsAvailable?.types?.yearlyPrepay} bottomText={"Yearly Memberships Available"} />
              <PurchasePlayers changeMethod={ChangeNumberPlayers} dataArray={defaultNumberPlayers} title={numberPlayers.name} />
              <PurchaseBill />
            </SectionRight>
          </ContainerWrapper>
        )}
      </>
    </SponsorshipSection>
  );
};